import { HomeAnnouncementPage } from './HomeAnnouncementPage';
export default HomeAnnouncementPage;
